import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="footer">
        <div className="container-fluid">
          <div className="row border-line">
            <div className="col-lg-4">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/logo.png"
                  alt="Carmel Convent School, dharuhera"
                  className="img-fluid"
                />
              </LazyLoad>
            </div>
            <div className="col-lg-8">
              <div className="social_media">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/insta.png"
                  className="social-media img-fluid"
                />
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/twitter.png"
                  className="social-media img-fluid"
                />
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/facebook.png"
                  className="social-media img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-4 col-xl-3">
              <h3>School Timings</h3>

              <div className="d-flex">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/time.gif"
                  className="img-fluid"
                />
                <div>
                  <p>
                    {" "}
                    Summer <span>7:45 AM to 1:15 PM</span>
                  </p>
                  <p>
                    Winter <span>8:30 AM to 2:00 PM</span>
                  </p>
                </div>
              </div>
              <h3>Office Timings</h3>
              <div className="d-flex">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/time.gif"
                  className="img-fluid"
                />
                <div>
                  <p>
                    Monday to Friday<span>9:00 AM to 12:00 AM</span> (Except
                    Govt. Holidays)
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-2">
              <h3>Our Links</h3>
              <ul>
                <li>
                  <i class="bi bi-chevron-right"></i> <Link to="/"> Home </Link>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i>
                  <Link to="/AboutUs"> About Us </Link>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i>
                  <Link to="/FeeStructure"> Fee Structure </Link>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i>
                  <Link to="/Gallery"> Photo Gallery</Link>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i>
                  <Link to="/ContactUs"> Contact Us </Link>
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4">
              <h3>Our Links</h3>
              <p>
                <Link
                  to="https://www.google.com/maps?q=28.1692234,76.7862046"
                  target="_blank"
                >
                  <i class="bi bi-geo-alt-fill"></i> Village Alawalpur near
                  Jyoti Hotel,Nandrampur Bass,
                  <br />
                  &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;Teh. Dharuhera, District
                  Rewari, Haryana 12310
                </Link>
              </p>
              <p>
                <Link to="mailto:carmelschooldharuhera@gmail.com">
                  <i class="bi bi-envelope-fill"></i>
                  carmelschooldharuhera@gmail.com
                </Link>{" "}
              </p>
              <p>
                <Link to="tel:+91 8168540345">
                  <i class="bi bi-telephone-fill"></i> +91 8168540345{" "}
                </Link>
              </p>
            </div>
            <div className="col-md-12 col-lg-8 col-xl-3">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3517.257208124909!2d76.78350317620563!3d28.169092204973698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s7JWR5Q9P%2BJCP!5e0!3m2!1sen!2sin!4v1758263296447!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        Copyright ©️ Carmel Convent School, {currentYear} . All Right Reserved.
        Accelerating By{" "}
        <a href="https://entab.in/" target="_blank">
          Entab Infotech : CampusCare®️
        </a>
      </div>
    </>
  );
};

export default Footer;
